import state from "./moduleMailTrashStates";
import mutations from "./moduleMailTrashMutations";
import actions from "./moduleMailTrashActions";
import getters from "./moduleMailTrashGetters";

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}